import styled from 'styled-components';

type PropsHistoryReceiving = {};
type PropsHistorySending = {};

export const HistoryReceivingStyled = styled.div<PropsHistoryReceiving>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  overflow-x: hidden;
  & .ant-table-container {
    width: 100vw;
    padding: 0 32px;
  }
  & .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.07);
    padding: 0 16px;
    word-break: break-word;
    white-space: pre-line;
  }
  & .ant-pagination-item-link {
    border: none;
    background-color: #f7f7f7;
  }
  & .ant-pagination-item-active a {
    background-color: #2666bf;
    color: white;
  }
  & .pagination {
    padding: 24px 0;
    text-align: center;
  }
  & .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.07);
    padding: 0 16px;
  }
  & .ant-table-wrapper {
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          padding-left: 0;
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
        }
      }
    }
  }
`;
export const HistorySendingStyled = styled.div<PropsHistorySending>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  overflow-x: hidden;

  & .ant-pagination-item-link {
    border: none;
    background-color: #f7f7f7;
  }
  & .ant-pagination-item-active a {
    background-color: #2666bf;
    color: white;
  }
  & .pagination {
    padding: 24px 0;
    text-align: center;
  }
  & .ant-table-container {
    width: 100vw;
    padding: 0 32px;
  }
  & .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.07);
    padding: 0 16px;
    word-break: break-word;
    white-space: pre-line;
  }
  & .ant-table-wrapper {
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          padding-left: 0;
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
        }
      }
    }
  }
`;
